/**
 * The sentence typed under the tree, carried to the door it opens — without
 * ever being written into a URL (2026-09-30 拍板).
 *
 * Until then the homepage composer put the words themselves on the query
 * string (`/talk?say=I+feel+…`, `/collect?…&say=…`). An in-app browser reports
 * every URL it opens to its platform, and the platform's link scanners replay
 * it later from anywhere (prod, 30 days: 65 fresh browsers replaying leaked
 * /talk URLs, three of five sampled carrying the person's first sentence).
 * The first thing somebody tells Ember must not be readable from the address.
 *
 * So the URL carries a handle — random, meaningless on its own — and the words
 * wait in this browser's sessionStorage under it: the same tab survives a
 * reload and a trip to Messages or the Google door and still finds them; a
 * copied or leaked URL finds nothing. The entry that read the words takes them
 * out once they have been said, so a Back onto the page does not say them
 * again. When the browser gives no storage (a private window that throws),
 * the words do not travel and the person types them again — the door still
 * opens; ui.failed talk_handoff / storage_unavailable counts how often.
 */

const PREFIX = 'ember.say:';

/** Keep the sentence for the door about to open; '' when it could not be kept. */
export function stashSay(line: string): string {
  const text = String(line || '').trim();
  if (!text) return '';
  const handle = Math.random().toString(36).slice(2, 12);
  try {
    window.sessionStorage.setItem(PREFIX + handle, text);
    return handle;
  } catch {
    return '';
  }
}

/** The sentence a handle names, '' when this browser holds none for it. */
export function readSay(handle: string): string {
  if (!handle) return '';
  try {
    return String(window.sessionStorage.getItem(PREFIX + handle) || '');
  } catch {
    return '';
  }
}

/** The sentence has been said: forget it. */
export function clearSay(handle: string): void {
  if (!handle) return;
  try {
    window.sessionStorage.removeItem(PREFIX + handle);
  } catch {
    /* nothing to forget */
  }
}
